<template>
	<Modal
		v-model:visible="visible"
		:title="$t('settings.vrsSettingsForm.containerIpAddr')"
		:destroyOnClose="true"
		:closable="!isSubmitting"
		:keyboard="!isSubmitting"
		:maskClosable="!isSubmitting"
		@ok="onOk"
		@cancel="onCancel"
	>
		<Form
			:model="formState"
			:label-col="{ span: 12 }"
			:wrapper-col="{ span: 12 }"
			:colon="false"
		>
			<FormItem
				:label="$t('settings.vrsSettingsForm.ipPortAccessSettings.host')"
				v-bind="validateInfos.value"
			>
				<InputRestricted
					v-model="formState.value"
					:allowedFormatChecker="hostnameChecker"
					:toolTipText="$t('validators.hostnameMessage')"
					showTooltipOnFocus
				/>
			</FormItem>
		</Form>
		<template #footer>
			<div class="flex-wrapper">
				<Button key="auto" @click="onAutoDetect" :loading="isSubmitting">{{ $t('settings.vrsSettingsForm.autoDetectButtonLabel') }}</Button>
				<div class="flex-grow"></div>
				<Button key="back" @click="onCancel" :loading="isSubmitting">{{ $t('settings.vrsSettingsForm.cancelButtonLabel') }}</Button>
				<Button type="primary" @click="onOk" :loading="isSubmitting">{{ $t('settings.vrsSettingsForm.buttonLabel') }}</Button>
			</div>
		</template>
	</Modal>
</template>

<script>
import { reactive, ref, toRaw, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import { Modal, Form, FormItem, Button, message } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

import Api from '@/api/Api';
import Validators from '@/api/Validators';
import Utils from '@/api/Utils';

import { showErrorMessage } from '@/components/common/errorMessage';

import InputRestricted from '@/components/common/InputRestricted.vue';

const get_default_state = () => ({
	key: '',
	value: '',
})


export default {
	components: {
		Modal, Form, FormItem, InputRestricted, Button,
	},
	emits: ['update:modelValue'],
	props: ['modelValue', 'onUpdate', 'item'],
	setup(props, { emit }) {
		const { t } = useI18n();
		const visible = useVModel(props, 'modelValue', emit);
		const initialFormState = reactive(get_default_state());
		const formState = reactive(get_default_state());
		const { validate, validateInfos } = Validators.useVRSSettingsCasterIpFormRules(formState);
		const isSubmitting = ref(false);

		watch(() => props.item, value => {
			if (value) {
				Utils.updateObject(initialFormState, value);
				Utils.updateObject(formState, initialFormState);
			}
		});

		watch(() => props.modelValue, value => {
			if (value) {
				Utils.updateObject(formState, initialFormState);
			}
		});

		const requestHandler = response => {
			if (response.status === 'ok') {
				message.success(t('settings.vrsSettingsForm.messages.success'));
				visible.value = false;
				props.onUpdate();
			} else {
				showErrorMessage(response.errors);
			}
			isSubmitting.value = false;
		};

		const onOk = () => {
			validate().then(() => {
				isSubmitting.value = true;
				Api.vrsSettingItemPost(toRaw(formState), requestHandler);
			}).catch(err => {
				console.log('error', err);
			});
		};

		const onAutoDetect = () => {
			isSubmitting.value = true;
			Api.containerIpAddrAutoDetect(requestHandler);
		};

		const onCancel = () => {
			visible.value = false;
		};

		return {
			visible,
			formState,
			validateInfos,
			isSubmitting,
			hostnameChecker: Validators.hostnameChecker,
			onOk,
			onAutoDetect,
			onCancel,
		};
	},
}
</script>
